<template>
    <DCard>
        <DTable
            :items="permissions.items"
            :fields="[
                {key: 'rowId', label: __('settings.permissions.table.headers.id')},
                {key: 'name', label: __('settings.permissions.table.headers.name')},
                {key: 'descriptionEn', label: __('settings.permissions.table.headers.description_en')},
                {key: 'descriptionDe', label: __('settings.permissions.table.headers.description_de')},
                {key: 'actions', label: ''}
            ]"
        >
            <template #actions="{item}">
                <td style="width: 150px">
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            v-if="userPermissions.includes('setting.permissions.edit')"
                            :id="`${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get($route('settings.permissions.edit', { permission: item.id }))"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="permissions.last_page > 1"
            :active-page="permissions.current_page"
            :pages="permissions.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>
export default {
    name: 'PermissionsIndex',
    props: {
        permissions: {
            type: Object,
            default: () => { return {} }
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('settings.permissions.index'), query)
        }
    }
}
</script>
